import React from "react"

import { OutboundLink } from 'gatsby-plugin-google-analytics'

import linkedinLight from "../../images/social/linkedin-light.svg"
import linkedinDark from "../../images/social/linkedin-dark.svg"
import linkedinBlack from "../../images/social/linkedin-black.svg"

import styles from "./socialLinks.module.scss"

import { LINKEDIN_URL } from "../../constants.js"

const images = {
  linkedinLight,
  linkedinDark,
  linkedinBlack
}

const LinkedInLink = ({ variant, share, shareCopy }) => {
  if (share) {
    return (
      <OutboundLink
        href={`https://www.linkedin.com/sharing/share-offsite?url=https://www.tillfinancial.io&title=Till Financial&summary=${shareCopy}&source=https://www.tillfinancial.io`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={styles.img}
          src={images[`linkedin${variant}`]}
          alt="LinkedIn Logo"
          layout="fixed"
        />
      </OutboundLink>
    )
  }

  return (
    <OutboundLink href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
      <img
        className={styles.img}
        src={images[`linkedin${variant}`]}
        alt="LinkedIn Logo"
        layout="fixed"
      />
    </OutboundLink>
  )
}

LinkedInLink.defaultProps = {
  shareCopy: "I’m getting early access to Till -- the app designed for real families to empower kids with the tools for spending, saving, and investing. Get Till at https://www.tillfinancial.io"
}

export default LinkedInLink
